import { Routes } from '@angular/router';
import { TenantShell } from './shell/tenant-shell/tenant-shell';
import { brandedTenantPortalGuard } from './core/guards/branded-tenant-portal.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/tenant-login').then((m) => m.TenantLogin),
  },
  {
    path: 'mfa/select',
    loadComponent: () =>
      import('./pages/mfa-method-select/tenant-mfa-method-select').then((m) => m.TenantMfaMethodSelect),
  },
  {
    path: 'mfa/verify',
    loadComponent: () => import('./pages/mfa-verify/tenant-mfa-verify').then((m) => m.TenantMfaVerify),
  },
  {
    path: '',
    component: TenantShell,
    canActivate: [brandedTenantPortalGuard],
    canActivateChild: [brandedTenantPortalGuard],
    children: [
      {
        path: 'setup',
        title: 'Complete your setup | Apex Habitat',
        loadComponent: () => import('./pages/setup/tenant-setup').then((m) => m.TenantSetup),
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'notifications',
        loadComponent: () => import('./pages/notifications/notifications').then((m) => m.Notifications),
      },
      {
        path: 'maintenance',
        loadComponent: () => import('./pages/maintenance/maintenance').then((m) => m.Maintenance),
      },
      {
        path: 'rents-payment',
        loadComponent: () => import('./pages/payments/tenant-payments').then((m) => m.TenantPayments),
      },
      {
        path: 'payments',
        loadComponent: () => import('./pages/payments/tenant-payments').then((m) => m.TenantPayments),
      },
      {
        path: 'calendar',
        loadComponent: () => import('./pages/calendar/tenant-calendar').then((m) => m.TenantCalendar),
      },
      {
        path: 'documents',
        loadComponent: () => import('./pages/documents/tenant-documents').then((m) => m.TenantDocuments),
      },
      {
        path: 'leases',
        loadComponent: () => import('./pages/leases/tenant-leases').then((m) => m.TenantLeases),
      },
      {
        path: 'messages',
        loadComponent: () => import('./pages/section/tenant-section').then((m) => m.TenantSection),
        data: {
          kind: 'MESSAGES',
          title: 'Messages',
          subtitle: 'Messages from your property team will appear here.',
        },
      },
      {
        path: 'inspections',
        loadComponent: () => import('./pages/inspections/tenant-inspections').then((m) => m.TenantInspections),
      },
      {
        path: 'communications',
        loadComponent: () => import('./pages/communications/tenant-communications').then((m) => m.TenantCommunications),
      },
      {
        path: 'support',
        loadComponent: () => import('./pages/support/tenant-support').then((m) => m.TenantSupport),
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/tenant-settings').then((m) => m.TenantSettings),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
